import api from '@pray/shared/utils/api';

import type { ListReportsResponse } from './data/response';

type ListReportsProps = {
  artistId: string;
  limit?: number;
  offset?: number;
};

export async function listReports({
  artistId,
  limit = 25,
  offset = 0,
}: ListReportsProps): Promise<ListReportsResponse> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/reports`;
  const params = {
    limit,
    offset,
  };

  const response = await api.executeGetRequest<ListReportsResponse>(url, params);
  return response.data;
}
